// extracted by mini-css-extract-plugin
module.exports = {"reportWrapper":"styles_reportWrapper__3DhF0"};